import React from "react"
import classes from "./ResultSet.module.css"
import Select from "react-select"
import { default_single_style, useLocalStorage } from "../../../Utils"
import { useTranslation } from "react-i18next"
import { defaultProfile, defaultBynameData } from "../../../DefaultEntries"
import { get_byname_adj_list, get_byname_sub_list } from "../../Byname/Byname"

const ControlInit = props => {
    const [t, i18n] = useTranslation()
    const [profile] = useLocalStorage("profile", defaultProfile)

    const default_adjectives = get_byname_adj_list(t, i18n, profile.BynameAdjectiveMap)
    const default_subject = get_byname_sub_list(t, i18n, profile.BynameSubjectMap)

    const [currentPulls, setCurrentPulls] = useLocalStorage(
        `finder_${props.localKey}`,
        defaultBynameData(default_adjectives[0], default_subject[0])
    )

    const changePull = (val, idx) => {
        const new_arr = [...currentPulls]
        new_arr[idx] = val
        setCurrentPulls(new_arr)
    }

    const changeSub = (elem, idx) => {
        changePull({ ...currentPulls[idx], ValueSub: elem }, idx)
    }

    const changeAdj = (elem, idx) => {
        changePull({ ...currentPulls[idx], ValueAdj: elem }, idx)
    }

    const addEntry = () => {
        const new_arr = [...currentPulls]
        new_arr.push({ Num: currentPulls.length + 1, ValueAdj: default_adjectives[0], ValueSub: default_subject[0] })
        setCurrentPulls(new_arr)
    }

    const removeEntry = () => {
        const new_arr = [...currentPulls]
        new_arr.pop()
        setCurrentPulls(new_arr)
    }

    return (
        <div className={classes.WrapperNoScroll}>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentPulls.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("misc:SeedListing.Pull")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            {currentPulls.map((entry, idx) => {
                return (
                    <Entry
                        num={entry.Num}
                        key={entry.Num}
                        onChangeSub={changeSub}
                        onChangeAdj={changeAdj}
                        idx={idx}
                        valueAdj={currentPulls[idx].ValueAdj}
                        valueSub={currentPulls[idx].ValueSub}
                    />
                )
            })}
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentPulls.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("misc:SeedListing.Pull")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} onClick={() => props.findSeed(currentPulls)}>
                    {t("misc:Recovery.ButtonSearch")}
                </button>
            </div>
        </div>
    )
}

const Entry = props => {
    const [profile] = useLocalStorage("profile", defaultProfile)

    const [t, i18n] = useTranslation()
    const default_adjectives = get_byname_adj_list(t, i18n, profile.BynameAdjectiveMap)
    const default_subject = get_byname_sub_list(t, i18n, profile.BynameSubjectMap)
    const ss = default_single_style()

    return (
        <div className={classes.PullEntry}>
            <div className={classes.PullHeader}>
                {props.num}. {t("translation:CommonMsg.Glossary.Byname")}
            </div>
            <Select
                defaultValue={default_adjectives[0]}
                name="adjectives"
                options={default_adjectives}
                value={props.valueAdj}
                styles={ss}
                onChange={elem => props.onChangeAdj(elem, props.idx)}
            />
            <Select
                defaultValue={default_subject[0]}
                name="subjects"
                options={default_subject}
                value={props.valueSub}
                styles={ss}
                onChange={elem => props.onChangeSub(elem, props.idx)}
            />
        </div>
    )
}

export default ControlInit
